// auth.service.ts

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpService } from "./http.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private baseUrl = environment.url;
  private investorUrl = environment.url;
  private _isAuthenticated = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private httpService: HttpService,
    private modalService: NgbModal
  ) {}

  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post(`${this.investorUrl}auth/login`, credentials, {
      headers: this.httpService.getHeaders(),
      withCredentials: true
    });
  }

  logout() {
    this.modalService.dismissAll();
    this.setAuthenticated(false);
    localStorage.removeItem('userData');
    
    // Invalidate the session cookie on the backend
    this.http.post(`${this.investorUrl}auth/logout`, {}, {
      headers: this.httpService.getHeaders(),
      withCredentials: true
    }).subscribe({
      next: () => console.log('Logged out from server successfully'),
      error: (err) => console.error('Server-side logout failed', err)
    });

    this.router.navigate(["/login"]);
  }

  isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  setAuthenticated(value: boolean) {
    this._isAuthenticated = value;
  }

  checkSession(): Observable<any> {
    return this.http.get(`${this.baseUrl}users/profile`, {
      headers: this.httpService.getHeaders(),
      withCredentials: true
    });
  }

  rememberMe(isRemember: boolean) {
    localStorage.setItem("rememberMe", isRemember.toString());
  }
}
